import type { BoxDimensions, Dimensions } from '@/types/BoundingBox.types';

export const scaleCoordinates = (
  box: BoxDimensions,
  imageSize: Dimensions,
  naturalSize: Dimensions,
  containerSize: Dimensions
): BoxDimensions => {
  if (
    imageSize.width === 0 ||
    naturalSize.width === 0 ||
    containerSize.width === 0
  ) {
    return { x: 0, y: 0, width: 0, height: 0 };
  }

  const scale = Math.min(
    imageSize.width / naturalSize.width,
    imageSize.height / naturalSize.height
  );

  const leftMargin = (containerSize.width - naturalSize.width * scale) / 2;
  const topMargin = (containerSize.height - naturalSize.height * scale) / 2;

  return {
    x: leftMargin + box.x * naturalSize.width * scale,
    y: topMargin + box.y * naturalSize.height * scale,
    width: box.width * naturalSize.width * scale,
    height: box.height * naturalSize.height * scale,
  };
};

export const reverseScaleCoordinates = (
  box: BoxDimensions,
  imageSize: Dimensions,
  naturalSize: Dimensions,
  containerSize: Dimensions
): BoxDimensions => {
  const scale = Math.min(
    imageSize.width / naturalSize.width,
    imageSize.height / naturalSize.height
  );

  const leftMargin = (containerSize.width - naturalSize.width * scale) / 2;
  const topMargin = (containerSize.height - naturalSize.height * scale) / 2;

  const normX = (box.x - leftMargin) / (naturalSize.width * scale);
  const normY = (box.y - topMargin) / (naturalSize.height * scale);
  const normWidth = box.width / (naturalSize.width * scale);
  const normHeight = box.height / (naturalSize.height * scale);

  return {
    x: Math.max(0, Math.min(1, normX)),
    y: Math.max(0, Math.min(1, normY)),
    width: Math.max(0, Math.min(1 - normX, normWidth)),
    height: Math.max(0, Math.min(1 - normY, normHeight)),
  };
};
